import { ApiResponse } from '@nohara-dxdev/oidc-core';
import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { NotificationEntity } from '@/types/api';

export const getOrgNotifications = async (orgId: string): Promise<NotificationEntity[]> => {
  const { data } = await api.get<undefined, ApiResponse<{ notifications: NotificationEntity[] }>>(
    `/orgs/${orgId}/notifications`,
  );
  return data.notifications;
};

export const getProjectNotifications = async (
  orgId: string,
  projectId: string,
): Promise<NotificationEntity[]> => {
  const { data } = await api.get<undefined, ApiResponse<{ notifications: NotificationEntity[] }>>(
    `/orgs/${orgId}/projects/${projectId}/notifications`,
  );
  return data.notifications;
};

export const getNotificationsQueryKey = (
  orgId: string | undefined | null,
  projectId?: string | null,
) => ['notifications', 'list', orgId, ...(projectId ? [projectId] : [])];

export const useNotifications = () => {
  const { orgId, projectId } = useScopeIds();

  return useQuery({
    queryKey: getNotificationsQueryKey(orgId, projectId),
    queryFn: () => {
      if (!orgId) return [];
      if (projectId) return getProjectNotifications(orgId, projectId);
      return getOrgNotifications(orgId);
    },
    enabled: !!orgId,
    staleTime: Infinity,
  });
};
